var ImageTools = {};


/**
 * Get base64 data url based on an Image object
 * @param  {Image} image
 * @return {string}
 */
ImageTools.getBase64EncodedImage = function (image) {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, image.width, image.height);
    canvas.width = image.width;
    canvas.height = image.height;
    ctx.drawImage(image, 0, 0, image.width, image.height);

    return canvas.toDataURL("image/jpeg");
};

export default ImageTools;
